import React from 'react'
import cx from 'classnames'

import styles from './styles.module.sass'


export const Icon = ({ symbol, className, ...props }) =>
  <div className={cx( styles.icon, styles[symbol], className )} {...props} />
